import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { catchError, combineLatest, map } from 'rxjs';
import { StepDataBridgeService } from '../step-modules/root-step/services/step-data-bridge.service';

export const stepNavigationGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const stepDataBridgeService = inject(StepDataBridgeService);
  return combineLatest([stepDataBridgeService.loadAllSteps$(), stepDataBridgeService.loadRootStep$()]).pipe(
    map(() => true),
    catchError(() => {
      throw new Error('cant get rootStep');
    }),
  );
};
